import { useEffect, useState } from "react"

export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => {
        if (typeof window !== "undefined") {
            return window.matchMedia(query).matches
        }
        return false
    })

    useEffect(() => {
        if (typeof window === "undefined") return
        const media = window.matchMedia(query)
        const listener = () => setMatches(media.matches)
        media.addEventListener("change", listener)
        return () => media.removeEventListener("change", listener)
    }, [query])

    return matches
}


export function useDeviceType() {
    const isMobile = useMediaQuery("(max-width: 768px)")
    const isTablet = useMediaQuery("(min-width: 769px) and (max-width: 1024px)")
    const isDesktop = useMediaQuery("(min-width: 1025px)")

    return { isMobile, isTablet, isDesktop }
}